module.exports = __webpack_public_path__ + "static/img/产品中心-AI融合管理平台-反三违.dc878d3d.jpg";